import { render, staticRenderFns } from "./WapProductSelect.vue?vue&type=template&id=54a1b69e&"
import script from "./WapProductSelect.vue?vue&type=script&lang=js&"
export * from "./WapProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports